import styled from 'styled-components';

/**
 * Best-effort initial clamp before a menu measures itself. Assumes a
 * ~140px×120px menu so the first paint already lands inside the viewport
 * even though the precise size depends on font rendering.
 */
export function initialClamp(x: number, y: number): { x: number; y: number } {
  const margin = 8;
  const approxW = 140;
  const approxH = 120;
  if (typeof window === 'undefined') return { x, y };
  return {
    x: Math.max(margin, Math.min(x, window.innerWidth - approxW - margin)),
    y: Math.max(margin, Math.min(y, window.innerHeight - approxH - margin)),
  };
}

// Match the order-builder Select.Content (8px radius, --bg-color-page,
// rgba(white, 0.5) item text → full white on hover) so the right-click
// menu reads as part of the same visual family. No transitions / no
// slide-in: the menu just appears at its measured position
// (useLayoutEffect ensures the first paint is already clamped).
export const MenuPositioned = styled.div`
  position: fixed;
  z-index: 99999;
  min-width: 140px;
  background: var(--bg-color-page);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 4px;
  display: flex;
  flex-direction: column;
`;

export const MenuItem = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  padding: 6px 8px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: ${(p) =>
    p.$danger === true ? 'var(--error-color, #e3415a)' : 'var(--text-primary)'};
  font-size: 0.75rem;
  line-height: 1.125rem;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--hover-bg);
    color: ${(p) =>
      p.$danger === true
        ? 'var(--error-color, #e3415a)'
        : 'var(--text-primary)'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
